import { helpers, required } from "@vuelidate/validators";

export default () => ({
    diagnosisDate: {
        required: helpers.withMessage("The diagnosis date field is required.", required),
    },
});
